import React from 'react'
import { Box } from '@material-ui/core'
import { useStyles } from './styles'
import Button from 'web/src/app/root/components/common/button'
import Input from 'web/src/app/root/components/common/input'
import { ImagesSection } from '../'

export const CommentCardEdit = ({
    addComment,
    isCommentInEditMode,
    setCommentText,
    commentText,
    locale,
    imagesForUpload,
    setImagesForUpload,
    deletedPictureKeys,
    setDeletedPictureKeys,
    isEdit,
    postComment,
    report,
    setAddComment,
    setIsEdit,
    setCommentId
}) => {
    const classes = useStyles()

    return addComment && isCommentInEditMode ? (
        <Box>
            <Box className={classes.textareaSection}>
                <Input
                    multiline={true}
                    className={classes.textareaInput}
                    setValue={setCommentText}
                    value={commentText}
                    placeholder={locale.reports.enterCommentPlaceholder}
                    style={{
                        display: 'block'
                    }}
                />
            </Box>
            <ImagesSection
                imagesForUpload={imagesForUpload}
                setImagesForUpload={setImagesForUpload}
                deletedPictureKeys={deletedPictureKeys}
                setDeletedPictureKeys={setDeletedPictureKeys}
                isEdit={isEdit}
            />
            <Box className={classes.buttonsWrapper}>
                <Button
                    className={classes.saveButton}
                    onClick={() => postComment(commentText, report)}>
                    {locale.reports.save}
                </Button>
                <Button
                    reverted
                    style={{
                        marginLeft: '10px'
                    }}
                    sign
                    className={classes.saveButton}
                    onClick={() => {
                        setImagesForUpload([])
                        setAddComment(false)
                        setIsEdit(false)
                        setCommentId(null)
                        setDeletedPictureKeys([])
                    }}>
                    {locale.reports.cancle}
                </Button>
            </Box>
        </Box>
    ) : null
}
